<template>
  <hm-content title="">
    <div class="flex flex-start mb10">
      当前经销商商: <span class="primary">{{ storeNames }}</span>
      <span class="blue"
      >总计关联商户数{{ supplierAgencyShopRelListBox.length }}家</span
      >
    </div>
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" @click="addShop"
        >新增门店</el-button
        >
      </div>
      <div>
        <el-input
            clearable
            style="width:250px"
            v-model.trim="searchCondition.shopName"
            placeholder="请输入门店名称"
            size="small"
            class="ipt mr10"
        ></el-input>
        <el-select
            size="small"
            clearable
            class="mr10"
            placeholder="选择商户"
            v-model="searchCondition.storeCode"
            style="width: 200px"
            filterable
        >
          <el-option
              v-for="(item, i) in supplierAgencyShopRelListBox"
              :key="i"
              :label="item.storeName"
              :value="item.storeCode"
          ></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table-panel flex flex-between">
      <div>
        <span>已选{{ mainTableCheckedData.length }}条</span>
      </div>
      <div>
        <span @click="batchDel" class="pointer">
          <span class="delete-icon hmicon icon-shanchu "></span>
          批量删除
        </span>
      </div>
    </div>
    <div class="table">
      <el-table
          :data="list"
          style="width: 100%"
          stripe
          @selection-change="getListChecked"
          size="small"
          border
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            label="商户名"
            prop="storeName"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="shopName"
            label="门店名称"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            label="所在省/市/区"
            prop="citys"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.provinceName }}{{ scope.row.cityName
              }}{{ scope.row.districtName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="shopAddress"
            label="门店地址"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button size="small" type="text" @click="remove(scope.row)"
              >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
        :close-on-click-modal="false"
        :title="title"
        width="1600px"
        :before-close="qx"
        :visible.sync="dialogVisible"
    >
      <div class="flex">
        <div class=" mr10 " style="width:600px">
          <div class="table-panel flex flex-between">
            <div class="fr flex flex-end item-center" style="width: 100%">
              <el-input
                  clearable
                  v-model.trim="storeName"
                  placeholder="请输入商户"
                  size="small"
                  class="ipt mr10 fr"
              >
              </el-input>
              <el-button
                  class="fr"
                  type="primary"
                  size="small"
                  @click="storeSearch"
              >查询</el-button
              >
            </div>
          </div>
          <div class="table-panel">
            <div class="tables">
              <el-table
                  stripe
                  ref="roleTable"
                  :data="storeBasucList.records"
                  style="width: 100%"
                  id="table"
                  @row-click="storeTableSelect"
                  size="small"
                  border
                  max-height="500"
                  @selection-change="storeTableSelectionChange"
              >
                <el-table-column
                    type="selection"
                    header-align="center"
                    align="center"
                    width="50"
                >
                </el-table-column>
                <el-table-column
                    type="index"
                    label="序号"
                    align="center"
                    :index="
                    index => index + (storeCurrentPage - 1) * storePageSize + 1
                  "
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="storeName"
                    label="商户"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="shopCount"
                    width="90"
                    label="门店数"
                ></el-table-column>
              </el-table>
            </div>
            <div class="hm-pagination">
              <el-pagination
                  background
                  small
                  :pager-count="5"
                  :total="storeBasucList.total"
                  @current-change="storePaging"
                  @size-change="storeHandleSizeChange"
                  layout="total,sizes,  prev, pager, next, jumper"
                  :current-page="storeCurrentPage"
              ></el-pagination>
            </div>
          </div>
        </div>
        <div class="mar10 seach_checked flex flex-center item-center mr10">
          <el-button class="btn" type="primary" size="small" @click="searchShop"
          >查询勾选商户门店</el-button
          >
        </div>
        <div class="mr10 w60" style="width:800px">
          <div class="table-panel">
            <div class="fr flex flex-end item-center">
              <el-input
                  clearable
                  v-model.trim="shopName"
                  placeholder="请输入门店名称"
                  size="small"
                  class="ipt mr10"
              ></el-input>
              <el-button type="primary" size="small" @click="shopSearch"
              >查询</el-button
              >
            </div>
          </div>
          <div class="table-panel">
            <div class="table">
              <el-table
                  stripe
                  ref="rightData"
                  :data="notRelShopList"
                  style="width: 100%"
                  id="table"
                  size="small"
                  @row-click="shopTableSelect"
                  @selection-change="getShopChecked"
                  border
                  max-height="500"
              >
                <el-table-column type="selection"></el-table-column>
                <el-table-column
                    type="index"
                    label="序号"
                    :index="
                    index => index + (shopCurrentPage - 1) * shopPageSize + 1
                  "
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="storeName"
                    label="商户"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    width="150"
                    prop="shopName"
                    label="门店名称"
                >
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    label="所在省/市/区"
                    prop="citys"
                >
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.provinceName }}{{ scope.row.cityName
                      }}{{ scope.row.districtName }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    label="详细地址"
                    prop="shopAddress"
                >
                </el-table-column>
              </el-table>
            </div>
            <div class="hm-pagination">
              <el-pagination
                  small
                  background
                  :total="notRelShopTotal"
                  @current-change="shopPaging"
                  @size-change="shopHandleSizeChange"
                  layout="total,sizes, prev, pager, next, jumper"
                  :current-page="shopCurrentPage"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="confirm()"
        >确 定</el-button
        >
        <el-button size="small" @click="qx">取 消</el-button>
      </div>
    </el-dialog>

<!--    <el-dialog
        :visible.sync="errValidImport"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        :append-to-body="true"
        width="600px">
      <div slot="title">
        <span class="dialog-title">导入失败</span>
        <span class="ml10 " style="color: red; font-size: 14px" >商品名/门店有误、重复都会导致导入失败</span>
      </div>
      <div class="mt20" style="font-size: 14px">
        您有<span style="color: red">{{errInputResult.length}}</span>条数据导入失败
      </div>
      <div class="mt20" >
        <el-table :data="errInputResult" border class="small-table">
          <el-table-column prop="storeName" header-align="center" align="center" label="商户"></el-table-column>
          <el-table-column prop="shopName" header-align="center" align="center" label="门店"></el-table-column>
        </el-table>
      </div>
    </el-dialog>-->
  </hm-content>
</template>

<script>
import {mapGetters} from "vuex";
import {post} from "@/utils/utils";

export default {
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {
        shopName: "",
        storeCode: ""
      },
      storeNames: "",
      supplierAgencyShopRelListBox: [],
      dialogVisible: false,
      errValidImport: false,
      errInputResult: [],
      storePageSize: 10,
      storeCurrentPage: 1,
      shopCurrentPage: 1,
      shopPageSize: 10,
      notRelShopList: [],
      notRelShopTotal: 0,
      mainTableCheckedData: [],
      storeTableCheckedData: [],
      shopTableCheckedData: [],
      title: "",
      storeName: "",
      shopName: "",
      storeCodeList: [],
    };
  },
  computed: mapGetters([
    "storeBasucList",
  ]),
  created() {},
  mounted() {
    this.storeNames = localStorage.getItem("storeName");
    this.queryList();
    this.queryAgencyRelShopListBox();
  },
  methods: {
    async queryAgencyRelShopListBox() {
      const { result } = await this.$store.dispatch("queryAgencyRelShopListBox", {agencyCode: this.$route.query.storeCode});
      this.supplierAgencyShopRelListBox = result;
    },
    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let list = [
          {shopId: row.shopId}
        ];
        let params = {
          agencyCode: this.$route.query.storeCode,
          shopInfoModelList: list
        }
        this.relShopDel(params);
      });
    },
    async relShopDel(params) {
      await this.$store.dispatch("agencyShopDel", params);
      this.$message({
        message: "操作成功！",
        type: "success"
      });
      this.queryList();
    },
    async confirm() {
      if (this.shopTableCheckedData && this.shopTableCheckedData.length > 0) {
        let params = {
          agencyCode: this.$route.query.storeCode,
          shopInfoModelList: this.shopTableCheckedData
        };
        await this.$store.dispatch("agencyShopSave", params);
        this.$message({
          message: "操作成功！",
          type: "success"
        });
        this.qx();
        this.queryList();
      } else {
        this.$message({
          message: "请选择门店",
          type: "warning"
        });
      }
    },
    async queryNotRelShop() {
      const { result } = await this.$store.dispatch("queryAgencyNotRelShopList",
          {
            pageSize: this.shopPageSize,
            pageNo: this.shopCurrentPage,
            shopName: this.shopName,
            storeCodeList: this.storeCodeList,
            supplierCode: this.$route.query.storeCode
          });
      const { total, records } = result;
      this.notRelShopList = records;
      this.notRelShopTotal = total;
    },
    shopSearch() {
      this.shopCurrentPage = 1;
      this.queryNotRelShop();
    },
    getShopChecked(val) {
      this.shopTableCheckedData = val;
    },
    shopTableSelect(row, column, event) {
      this.$refs.rightData.toggleRowSelection(row);
    },
    searchShop() {
      if (this.storeTableCheckedData && this.storeTableCheckedData.length > 0) {
        this.shopCurrentPage = 1;
        this.storeCodeList = this.storeTableCheckedData.map(v => v.storeCode);
        this.queryNotRelShop();
      } else {
        this.$message({
          message: "请选择商户",
          type: "warning"
        });
      }
    },
    storeTableSelectionChange(val) {
      this.storeTableCheckedData = val;
    },
    //左边表格表格选中
    storeTableSelect(row, column, event) {
      this.$refs.roleTable.toggleRowSelection(row);
    },
    storeSearch() {
      this.storeCurrentPage = 1;
      this.queryStoreList();
    },
    qx() {
      this.dialogVisible = false;
      this.rest();
    },
    rest() {
      setTimeout(() => {
        this.departIds = "";
        this.storeCode = "";
        this.storeName = "";
        this.shopName = "";
        this.storeBasucList.records = [];
        this.storeBasucList.total = 0;
        this.notRelShopList.records = [];
        this.notRelShopList.total = 0;
      }, 0);
    },
    //获取主列表选中数据
    getListChecked(val) {
      this.mainTableCheckedData = val;
    },
    //批量删除
    batchDel() {
      if (!this.mainTableCheckedData || this.mainTableCheckedData.length < 1) {
        return;
      }
      let params = {
        agencyCode: this.$route.query.storeCode,
        shopInfoModelList: JSON.parse(JSON.stringify(this.mainTableCheckedData))
      }
      this.relShopDel(params);
    },
    //查询
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    //查询商户分页列表
    queryStoreList() {
      let params = {
        pageSize: this.storePageSize,
        pageNo: this.storeCurrentPage,
        storeName: this.storeName
      };
      this.$store.dispatch("queryStoreBasicList", params);
    },
    //按钮添加门店操作
    addShop() {
      this.title = "新增门店";
      this.dialogVisible = true;
      this.notRelShopList = [];
      this.notRelShopTotal = 0;
      this.shopCurrentPage = 1;
      this.shopPageSize = 10;
      this.queryStoreList();
    },
    //查询分页数据
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        agencyCode: this.$route.query.storeCode,
        queryRewardFlag: "exclude",
        queryRewardNumStat: "exclude",
        queryShopStat: "include",
        queryTemplateStat: "exclude",
        queryRiskeStat: "exclude",
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch("queryAgencyShopList", params);
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    shopPaging(page) {
      this.shopCurrentPage = page;
      this.queryNotRelShop();
    },
    shopHandleSizeChange(size) {
      this.shopCurrentPage = 1;
      this.shopPageSize = size;
      this.queryNotRelShop();
    },
    storePaging(page) {
      this.storeCurrentPage = page;
      this.queryStoreList();
    },
    storeHandleSizeChange(size) {
      this.storeCurrentPage = 1;
      this.storePageSize = size;
      this.queryStoreList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
  },
};
</script>

<style scoped lang="scss">
.seach_checked {
  width: 160px;
  box-sizing: border-box;
}

</style>
